import { useTranslation } from 'react-i18next'
import './Footer.scss'
import i18n from '../../../i18n/i18n'
import LogoMobileES from '../../../assets/images/logos/logo-es.png'
import LogoMobilePT from '../../../assets/images/logos/logo-pt.png'
import LogoMobileEN from '../../../assets/images/logos/logo-en.png'

import Clip from '../../../assets/images/footer-logos/clip.png'
import mongabayLatam from '../../../assets/images/footer-logos/mongabay.png'
import dialogueEarth from '../../../assets/images/footer-logos/dialogue-earth.png'
import quintoElementoLab from '../../../assets/images/footer-logos/quinto-elemento.png'
import climateTrackerLatam from '../../../assets/images/footer-logos/climate-tracker.png'

import reporterBrasil from '../../../assets/images/footer-logos/reporter.png'
import ruido from '../../../assets/images/footer-logos/ruido.png'
import consenso from '../../../assets/images/footer-logos/consenso.png'
import laRegion from '../../../assets/images/footer-logos/la-region.png'
import cji from '../../../assets/images/footer-logos/cji.png'
import { Divider } from '@mui/material'
import { useEffect, useState } from 'react'

export const Footer = () => {
  const { t }: any = useTranslation();

  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    const handleChange = (e: any) => setIsMobile(e.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
}, [])


  const findLogo = () => {
    return i18n.language.includes('es') ? LogoMobileES : i18n.language.includes('pt') ? LogoMobilePT : LogoMobileEN;
  }

  return (
    <>
      <div className="footer-logos">
        <div className="logos-container">
          <ul>
            <li>
              <img src={Clip} alt="CLIP Logo" />
            </li>
            <li>
              <img
                style={{ maxWidth: '300px' }}
                src={mongabayLatam}
                alt="Mongabay Latam Logo"
              />
            </li>
            <li>
              <img src={dialogueEarth} alt="Dialogue Earth Logo" />
            </li>
            <li>
              <img src={quintoElementoLab} alt="Quinto Elemento Lab Logo" />
            </li>
            <li>
              <img src={climateTrackerLatam} alt="Climate Tracker Latam Logo" />
            </li>
          </ul>
          <ul>
            <li>
              <img src={reporterBrasil} alt="Reporter Brasil Logo" />
            </li>
            <li>
              <img
                style={{ maxWidth: '300px' }}
                src={ruido}
                alt="Ruido Logo"
              />
            </li>
            <li>
              <img src={consenso} alt="Consenso Logo" />
            </li>
            <li>
              <img src={laRegion} alt="La Región Logo" />
            </li>
            <li>
              <img src={cji} alt="Columbia Journalism Investigations Logo" />
            </li>
          </ul>
        </div>
      </div>
      <footer>
        <div className="credits-container">
          <div className="footer-logo">
            <img
              src={findLogo()}
              alt="Litio en Conflicto"
            />
          </div>

          <Divider
            sx={{ backgroundColor: '#fff', width: isMobile ? '100%' : '1px', height: isMobile ? '1px' : 'auto' }}
            orientation={isMobile ? 'horizontal' : 'vertical'}
            flexItem
          />

          <div className="credits">
            <div>
              <p>
                <b>{t('footer.creditsContainer.editorialCoordination')}:</b>{' '}
                Andrés Bermúdez Liévano {t('footer.and')} Centro Latinoamericano de Investigación
                Periodística (CLIP)
              </p>
              <p>
                <b>
                  {t('footer.creditsContainer.dataProcessing')}:
                </b>{' '}
                Ángela Cantador (CLIP)
              </p>
              <p>
                <b>
                  {t('footer.creditsContainer.reportingAndDataInvestigation')}:
                </b>{' '}
                  Andrés Bermúdez Liévano, Ángela Cantador, Iván Ruiz {t('footer.and')} María Teresa Ronderos (CLIP), Emilia Delfino (Argentina - Mongabay Latam), Thelma Gómez Durán ({t('countries.mexico')} - Quinto Elemento Lab), Isabel Harari ({t('countries.brazil')} - Repórter Brasil), Rocío Lloret Céspedes ({t('countries.bolivia')} - La Región & Dialogue Earth), Barinia Montoya ({t('countries.chile')} - Mongabay Latam), Maximiliano Manzoni ({t('countries.paraguay')} - Consenso & Climate Tracker), Carla Samon Ros {t('footer.and')} Johanna Hänsel (Columbia Journalism Investigations - CJI)
              </p>
              <p>
                <b>{t('footer.creditsContainer.production')}:</b> Luisa Fernanda
                López (CLIP)
              </p>
              <p>
                <b>{t('footer.creditsContainer.graphicDesign')}:</b> Alejandra
                Saavedra López
              </p>
              <p>
                <b>
                  {t(
                    'footer.creditsContainer.dataVisualizationAndWebDevelopment'
                  )}
                  :
                </b>{' '}
                Daniel Chinchilla Lizano {t('footer.and')} Diego Arce (CLIP)
              </p>
            </div>
          </div>
          <Divider
            sx={{ backgroundColor: '#fff', width: isMobile ? '100%' : '1px', height: isMobile ? '1px' : 'auto' }}
            orientation={isMobile ? 'horizontal' : 'vertical'}
            flexItem
          />
          <div className="footer-description">
            <p>{t('footer.description')}</p>
          </div>
        </div>
      </footer>
    </>
  )
}
